import { PinpointClient } from "@aws-sdk/client-pinpoint";
import { config } from "JS/Config";

export const initPinpoint = () => {
    return new PinpointClient({
        region: config.s3.region,
        credentials: {
            accessKeyId: config.s3.accessKey || "",
            secretAccessKey: config.s3.secretAccessKey || "",
        },
    });
};
